import mapFunction from './mapResources';

export default mapFunction('logs', {
    isFetching: false,
    items: [] 
});